module.exports = __webpack_public_path__ + "static/media/Slide28.6da22d93.jpg";